import styled from 'styled-components';
import { Typ41, Typ20 } from 'dc/Typ';

type ContainerProps = {
  colors: { primary: string; secondary: string };
};

export const Container = styled.div<ContainerProps>`
  position: relative;
  width: ${props => (props.theme.isMobile ? '100%' : '303px')};
  margin: ${props => (props.theme.isMobile ? '8px 0 0' : '8px 16px 0')};
  padding: 0 16px;
  border-radius: 8px;
  background: ${props =>
    props.colors
      ? `linear-gradient(98.57deg,${props.colors.primary} 0%,${props.colors.secondary} 100%)`
      : 'linear-gradient(98.57deg,#007079 0%,#35B8C4 100%)'};
  display: flex;
  flex-direction: row;
  cursor: pointer;
  overflow: hidden;
`;

type TextWrapperProps = {
  needsExtraPadding: boolean;
};

export const TextWrapper = styled.div<TextWrapperProps>`
  display: flex;
  flex-direction: column;
  padding: 16px 0;
  width: calc(100% - 48px);
  padding-right: ${props => (props.needsExtraPadding ? '32px' : '0')};
`;

export const Title = styled(Typ41)`
  font-size: 20px;
  margin-bottom: 24px;
  color: #fff;
`;

export const Link = styled(Typ20)`
  text-decoration: underline;
  color: #fff;
`;

type ImageProps = {
  hasBottomPadding?: boolean;
};

export const Image = styled.img<ImageProps>`
  position: absolute;
  bottom: ${props => (props.hasBottomPadding ? '13px' : 0)};
  right: 16px;
  max-width: 100%;
  height: auto;
`;
